import { IconButton as MuiIconButton } from '@mui/material';
import { Tooltip } from '@ghs/components';
import PropTypes from 'prop-types';
import { DeleteForever, Download, Edit } from '@mui/icons-material';

// eslint-disable-next-line
export const iconButtonConfig = {
    EDIT: {
        type: 'edit',
        icon: <Edit fontSize="small" color="primary" />,
        tooltip: 'Edit'
    },
    DELETE: {
        type: 'delete',
        icon: <DeleteForever fontSize="small" color="warning" />,
        tooltip: 'Delete'
    },
    DOWNLOAD: {
        type: 'download',
        icon: <Download color="primary" />,
        tooltip: 'Download'
    },
    CUSTOM_CHILDREN: {
        type: 'custom_children',
        icon: null,
        tooltip: ''
    }
};

/**
 * IconButton
 *
 * @typedef {{
 *  type: 'edit' | 'delete' | 'download' | custom_children;
 *  key: string;
 *  tooltip: string;
 *  onClick?: (value: boolean) => void;
 *  children?: node;
 * }} IconButtonProps
 * @param {IconButtonProps} props - props
 * @returns {React.ReactNode} IconButton component
 */
export default function IconButton(props) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { type, key, tooltip, onClick = () => {}, children } = props;
    const config = Object.values(iconButtonConfig).find(cfg => cfg.type === type) || iconButtonConfig.CUSTOM_CHILDREN;
    return (
        <Tooltip {...(key && { key: `${key}-tooltip` })} title={tooltip ? tooltip : config.tooltip} placement="bottom" arrow>
            <MuiIconButton {...(key && { key: `${key}-button` })} onClick={() => onClick()}>
                { (!type || type === iconButtonConfig.CUSTOM_CHILDREN.type) ? children : config.icon }
            </MuiIconButton>
        </Tooltip>
    );
}

IconButton.defaultProps = {
    type: iconButtonConfig.CUSTOM_CHILDREN.type
};

IconButton.propTypes = {
    type: PropTypes.oneOf(Object.keys(iconButtonConfig).map(key => iconButtonConfig[key].type)),
    key: PropTypes.string,
    tooltip: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node
};
